export default class ViewportHeight {
  constructor() {
    this.lastHeight = 0;
    this.init();
  }

  init = () => {
    this.throttle('resize', 'optimizedResize');
    this.setVH();
    window.addEventListener('optimizedResize', () => this.setVH());
  };

  throttle = (type, name) => {
    // https://devdocs.io/dom_events/resize
    let running = false;
    const func = () => {
      if (running) { return; }
      running = true;
      requestAnimationFrame(() => {
        window.dispatchEvent(new CustomEvent(name));
        running = false;
      });
    };
    window.addEventListener(type, func);
  };

  setVH = () => {
    // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01;

    if (window.innerWidth > window.innerHeight
      || Math.abs(this.lastHeight - window.innerHeight) > 100) {
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      this.lastHeight = window.innerHeight;
    }
  };
}
